import axiosInstance from "../../apiAxios/axiosInstance";

export const InventoryTransferList = async (payload) => {
  const response = await axiosInstance.post("/vendor/warehouse-transfer-list", payload);
  return response.data;
};

export const createInventryTransfer= async (payload) => {
  const response = await axiosInstance.post("/vendor/warehouse-transfer-store", payload);
  return response.data;
};

export const ViewInventryDetails = async (payload) => {
  const response = await axiosInstance.post("/vendor/warehouse-transfer-show", payload);
  return response.data;
};

export const UpdateWhereHouse = async (payload) => {
  const response = await axiosInstance.post("/vendor/warehouses-update", payload);
  return response.data;
};

export const DeleteInventory = async (payload) => {
  const response = await axiosInstance.post("/vendor/warehouses-delete", payload);
  return response.data;
};

export const WhereHouseChangeStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/vendor/warehouses-status-update",
    payload
  );
  return response.data;
};